import { Typography } from "@mui/material";

import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";

import {
  VehicleDamagesVisualModelViewerProps,
  VisualModelViewerOfVehicleDamages,
} from "./VisualModelViewerOfVehicleDamages";

export interface OwnProps {
  viewProps: VehicleDamagesVisualModelViewerProps;
}
type Props = OwnProps & Omit<AppModalProps, "children">;

export function VisualModelViewerOfVehicleDamagesModal({ viewProps, ...dialogProps }: Props) {
  const openStatus = useModalOpenStatus(dialogProps);

  return (
    <AppModal fullWidth maxWidth='xl' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        <Typography component='div' variant='h1' sx={{ display: "flex", alignItems: "center" }}>
          Vehicle damages
        </Typography>
      </AppModalTitle>

      <AppModalContent>
        {openStatus.isOpen && <VisualModelViewerOfVehicleDamages {...viewProps} />}
      </AppModalContent>
    </AppModal>
  );
}
